import axios from '../axios'

//查询来源
export const getSourceFilter = (data) => {
  return axios({
    url: '/con/notice/getSourceFilter',
    method: 'GET',
    data
  })
}
export const eduNoticesList = (data) => {
  return axios({
    url: '/con/notice/getEduNotices',
    method: 'GET',
    data
  })
}
//政策通知列表
export const getPolicyNotices = (data) => {
  return axios({
    url: '/con/notice/getPolicyNotices',
    method: 'GET',
    data
  })
}
//添加政策通知
export const addPolicyNotice = (data) => {
    return axios({
      url: '/con/notice/addPolicyNotice',
      method: 'GET',
      data
    })
  }
  export const delEduNotices = (data) => {
    return axios({
      url: '/con/notice/removeEduNotice', 
      method: 'GET',
      data
    })
  }
//政策通知详情
export const getPolicyNoticeDetail = (data) => {
  return axios({
    url: '/con/notice/getPolicyNoticeDetail',
    method: 'GET',
    data
  })
}

//删除政策通知
export const removePolicyNotice = (data) => {
    return axios({
      url: '/con/notice/removePolicyNotice',
      method: 'GET',
      data
    })
  }



// WEBPACK FOOTER //
// ./src/http/moudules/notificationManagement.js